import * as actionTypes from 'actions';

const initialState = {
  counts: [],
  loading: false,
  adjusting: false
};

const replaceCount = (counts, updated) => {
  const next = counts.slice();
  const idx = next.findIndex(
    c => c.deviceType === updated.deviceType && c.category === updated.category
  );
  if (idx === -1) {
    next.push(updated);
  } else {
    next[idx] = updated;
  }
  return next;
};

const inventoryCountReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FIND_INVENTORY_COUNTS_PENDING: {
      return { ...state, loading: true };
    }
    case actionTypes.FIND_INVENTORY_COUNTS_FULFILLED: {
      const incoming = action.payload.data.result || [];
      const merged = incoming.reduce(
        (acc, c) => replaceCount(acc, c),
        state.counts
      );
      return { ...state, counts: merged, loading: false };
    }
    case actionTypes.ADJUST_INVENTORY_COUNT_PENDING: {
      return { ...state, adjusting: true };
    }
    case actionTypes.ADJUST_INVENTORY_COUNT_FULFILLED: {
      const updated = action.payload.data.result;
      return {
        ...state,
        counts: updated ? replaceCount(state.counts, updated) : state.counts,
        adjusting: false
      };
    }
    default:
      return state;
  }
};

export default inventoryCountReducer;
